export const DOMAIN = 'organizationDetails';
